import { ThemeLogo } from 'components/themeLogo';
import { ThemeLogoType } from 'components/themeLogo';
import { UserId } from 'components/userId';
import styles from './FooterDisclaimer.module.scss';
import Link from 'next/link';
import { enLoading } from 'components/Image';
import { isTruthy } from 'utility/functions';

export type FooterDisclaimerProps = {
  disclaimerParagraph: string;
  certificationsBlock: CertificationBlock[];
};
export type CertificationBlock = {
  id: string;
  title: string;
  logoList: ThemeLogoType[];
};

export const FooterDisclaimer = ({ certificationsBlock, disclaimerParagraph }: FooterDisclaimerProps) => {
  return (
    <section className={styles.container}>
      <div className={styles.disclaimer}>
        <p className={styles.paragraph}>{disclaimerParagraph}</p>
        <p className={styles.paragraph} suppressHydrationWarning>
          {`Frontend Version: ${process.env.NEXT_PUBLIC_FRONTEND_VERSION ?? 'n.a.'}`}
        </p>
        {isTruthy(process.env.NEXT_PUBLIC_DEBUG) ? (
          <div>
            <p className={styles.paragraph}>
              {' '}
              user id: <UserId />
            </p>
          </div>
        ) : null}
      </div>
      <ul className={styles.logoSectionList}>
        {certificationsBlock?.map((item: CertificationBlock) => {
          return <LogoSectionItem key={item.id} title={item.title} logoList={item.logoList} />;
        })}
      </ul>
    </section>
  );
};

type LogoSectionItemProps = {
  title: string;
  logoList?: ThemeLogoType[];
};

const LogoSectionItem = ({ title, logoList }: LogoSectionItemProps) => {
  return (
    <li className={styles.logoSectionItem}>
      <h5 className={styles.title}>{title}</h5>
      <div className={styles.logosContainer}>
        {logoList?.map((logo: ThemeLogoType, index: number) => {
          const logoElement = (
            <ThemeLogo
              key={'logo_' + index}
              src={logo.src}
              alt={logo.alt}
              width={`${logoList.length > 1 || logo.alt === 'Partner - World Series Poker' ? 33 : 97}`}
              height={33}
              loading={enLoading.lazy}
              srcDarkMode={logo.srcDarkMode}
            />
          );

          return logo.link ? (
            <Link key={'link_' + index} href={logo.link} target="_blank" rel="noopener noreferrer">
              {logoElement}
            </Link>
          ) : (
            logoElement
          );
        })}
      </div>
    </li>
  );
};